import { TFunction } from "i18next";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";
import { EventsFiltersValues, EventsFormValues } from "../domain/models/Events";
import { Location } from "../domain/enums/location-enum";
import { Format } from "../domain/enums/format-enum";
import { enumToSelectProps } from "../tools/EnumTools";

export const EventsFiltersFields: Fields<EventsFiltersValues> = {
    title: {
        min: 2,
        max: 50,
        placeholderKey: "console.events.table.title",
        type: "text",
        optional: true,
        initial: "",
    },
    subtitle: {
        min: 2,
        max: 200,
        placeholderKey: "console.events.table.subtitle",
        type: "text",
        optional: true,
        initial: "",
    },
    description: {
        min: 2,
        max: 1_000_000,
        placeholderKey: "console.events.table.description",
        type: "text",
        optional: true,
        initial: "",
    },
    creatorId: {
        min: 1,
        max: 50,
        placeholderKey: "console.events.table.creatorId",
        type: "text",
        optional: true,
        initial: "",
    },
};

export const EventsFields: Fields<EventsFormValues> = {
    files: {
        type: "files",
        optional: true,
        initial: [],
    },
    eventDate: {
        type: "datetime-local",
        optional: false,
        placeholderKey: "console.events.table.eventDate",
        initial: "",
    },
    location: {
        type: "select",
        optional: false,
        placeholderKey: "console.events.table.location",
        selectOptions: enumToSelectProps(Location, "console.events.location"),
        initial: "",
    },
    format: {
        type: "select",
        optional: false,
        placeholderKey: "console.events.table.format",
        selectOptions: enumToSelectProps(Format, "console.events.format"),
        initial: "",
    },
    translations: {
        objectArray: {
            title: {
                min: 2,
                max: 50,
                placeholderKey: "console.events.table.title",
                type: "text",
                optional: false,
                initial: "",
            },
            subtitle: {
                min: 2,
                max: 200,
                placeholderKey: "console.events.table.subtitle",
                type: "text",
                optional: false,
                initial: "",
            },
            description: {
                min: 1,
                max: 1_000_000,
                placeholderKey: "console.events.table.description",
                type: "richtext",
                optional: false,
                initial: "",
            },
            // Fields that are set programmatically (not by the user, from entity)
            eventId: {
                type: "hidden",
                optional: true,
                initial: "",
            },
            languageCode: {
                type: "hidden",
                optional: true,
                initial: "",
            },
        },
        initial: [],
    },
};

export const eventsFiltersSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, EventsFiltersFields);
};

export const eventsSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, EventsFields);
};

